import { JetView } from 'webix-jet';
import { devConfig, profile, urlJs, urlJs2, walletcode } from 'config/config';

/**
 * Class representing a sports betting view.
 * @extends JetView
 */
export default class sportView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        var lng = 'es-ES'; // Default language set to Spanish
        // Determine the language based on the user's locale setting
        if (this.app.getService('locale').getLang() == 'en') {
            lng = 'en';
        } else {
            lng = 'es-ES';
        }
        var skinIdITN; // Variable to hold the skin ID for ITN
        // Set the skin ID based on the profile or default to 'doradobet'
        if (profile.skinIdITN == undefined || profile.skinIdITN == undefined || profile.skinIdITN == null) {
            skinIdITN = 'doradobet';
        } else {
            skinIdITN = profile.skinIdITN;
        }
        var typeSkinITN = '0'; // Variable to hold the type of skin
        var skinJsITN = ''; // Variable to hold the JavaScript skin
        typeSkinITN = profile.typeSkinITN; // Get the type of skin from the profile
        skinJsITN = profile.skinJsITN; // Get the JavaScript skin from the profile
        // Load the skin if the type is '1'
        if (typeSkinITN == '1') {
            webix.require([skinJsITN], function () {
                var options = {
                    token: profile.TokenSportsbook, // Token for the sportsbook
                    skinid: skinIdITN, // Skin ID
                    walletcode: profile.walletcodeSportbookITN, // Wallet code
                    full: true, // Full mode
                    page: 'prelive', // Page type
                    lang: lng, // Language
                    fixed: false, // Fixed mode
                };
                options.isHashMode = false; // Hash mode setting
                options.isHashClassesMode = true; // Hash classes mode setting
                // Callback for placing a bet
                options.placebetcallback = function (object) {
                    try {
                        // Check if the BetPhone is defined in the profile
                        if (profile.BetPhone != undefined && profile.BetPhone) {
                            webix
                                .ui({
                                    view: 'window',
                                    id: 'windowBetPhone', // ID for the phone betting window
                                    move: false,
                                    position: 'center',
                                    head: {
                                        view: 'toolbar',
                                        cols: [
                                            {
                                                view: 'label',
                                                label: _('Enviar SMS'), // Label for sending SMS
                                                align: 'center',
                                            },
                                            {
                                                view: 'icon',
                                                icon: 'wxi-close',
                                                click: function () {
                                                    this.getTopParentView().hide(); // Close the window
                                                },
                                            },
                                        ],
                                    },
                                    body: {
                                        view: 'form',
                                        id: 'betPhoneForm', // ID for the phone betting form
                                        elements: [
                                            {
                                                view: 'text',
                                                label: _('Ingrese su celular:'), // Label for phone input
                                                name: 'Phone', // Name of the input
                                                labelWidth: 150,
                                                labelPosition: 'top',
                                                required: true, // Required field
                                            },
                                            {
                                                view: 'text',
                                                label: _('Confirme  celular:'), // Label for phone confirmation input
                                                name: 'Phone2', // Name of the confirmation input
                                                labelWidth: 150,
                                                labelPosition: 'top',
                                                required: true, // Required field
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'button',
                                                        value: _('Cancelar'), // Cancel button label
                                                        click: function () {
                                                            this.getTopParentView().hide(); // Close the window
                                                            $$('betPhoneForm').setValues(
                                                                $$('betPhoneForm').getCleanValues(), // Reset form values
                                                            );
                                                        },
                                                    },
                                                    {
                                                        view: 'button',
                                                        type: 'form',
                                                        value: _('Enviar'), // Send button label
                                                        click: function ($e) {
                                                            var values = $$('betPhoneForm').getValues(); // Get form values
                                                            let params = {
                                                                Phone: values.Phone, // Phone number
                                                                Type: 'Bets', // Type of request
                                                                Code: object[0].betId, // Bet ID
                                                            };
                                                            // Validate the form
                                                            if ($$('betPhoneForm').validate()) {
                                                                // Check if phone numbers match
                                                                if (values.Phone == values.Phone2) {
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                            'Betshop/BetPhoneBetshop', // API endpoint
                                                                            params, // Parameters for the request
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message(
                                                                                        'Error! ', // Error message
                                                                                    );
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    var json = JSON.parse(
                                                                                        text, // Parse the response
                                                                                    );
                                                                                    // Check for errors in the response
                                                                                    if (json.HasError) {
                                                                                        webix.message({
                                                                                            title: _(
                                                                                                '¡Error!', // Error title
                                                                                            ),
                                                                                            type: 'alert-error',
                                                                                            text: json.AlertMessage, // Error message
                                                                                        });
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Apuesta Confirmada', // Success message
                                                                                        );
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    $$('betPhoneForm').setValues(
                                                                        $$('betPhoneForm').getCleanValues(), // Reset form values
                                                                    );
                                                                    this.getTopParentView().hide(); // Close the window
                                                                } else {
                                                                    webix.message({
                                                                        title: _(
                                                                            '¡Error!', // Error title
                                                                        ),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Celular y confirmar celular deben coincidir', // Error message
                                                                        ),
                                                                    });
                                                                }
                                                            } else {
                                                                webix.message({
                                                                    title: _(
                                                                        '¡Error!', // Error title
                                                                    ),
                                                                    type: 'alert-error',
                                                                    text: _(
                                                                        'Completa los campos...', // Error message
                                                                    ),
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                        elementsConfig: {
                                            on: {
                                                onChange: function () {
                                                    this.validate(); // Validate the form on change
                                                },
                                            },
                                        },
                                    },
                                })
                                .show(); // Show the window
                        } else {
                            // Check if the BetEmail is defined in the profile
                            if (profile.BetEmail != undefined && profile.BetEmail) {
                                webix
                                    .ui({
                                        view: 'window',
                                        id: 'windowBetEmail', // ID for the email betting window
                                        move: false,
                                        position: 'center',
                                        head: {
                                            view: 'toolbar',
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: 'Enviar Correo', // Label for sending email
                                                    align: 'center',
                                                },
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Close the window
                                                    },
                                                },
                                            ],
                                        },
                                        body: {
                                            view: 'form',
                                            id: 'betEmailForm', // ID for the email betting form
                                            elements: [
                                                {
                                                    view: 'text',
                                                    label: 'Ingrese su correo electrónico:', // Label for email input
                                                    name: 'Email', // Name of the input
                                                    labelWidth: 150,
                                                    labelPosition: 'top',
                                                    required: true, // Required field
                                                },
                                                {
                                                    view: 'text',
                                                    label: 'Confirme correo electrónico:', // Label for email confirmation input
                                                    name: 'Email2', // Name of the confirmation input
                                                    labelWidth: 150,
                                                    labelPosition: 'top',
                                                    required: true, // Required field
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button',
                                                            value: 'Cancelar', // Cancel button label
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Close the window
                                                                $$('betEmailForm').setValues(
                                                                    $$('betEmailForm').getCleanValues(), // Reset form values
                                                                );
                                                            },
                                                        },
                                                        {
                                                            view: 'button',
                                                            type: 'form',
                                                            value: 'Enviar', // Send button label
                                                            click: function ($e) {
                                                                var values = $$('betEmailForm').getValues(); // Get form values
                                                                let params = {
                                                                    Email: values.Email, // Email address
                                                                    Type: 'Bets', // Type of request
                                                                    Code: object[0].betId, // Bet ID
                                                                };
                                                                // Validate the form
                                                                if ($$('betEmailForm').validate()) {
                                                                    // Check if emails match
                                                                    if (values.Email == values.Email2) {
                                                                        webix
                                                                            .ajax()
                                                                            .headers({
                                                                                'Content-type': 'application/json', // Set content type
                                                                            })
                                                                            .post(
                                                                                devConfig.geturlApi() +
                                                                                'BetShop/BetEmailBetshop', // API endpoint
                                                                                params, // Parameters for the request
                                                                                {
                                                                                    error: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        webix.message(
                                                                                            'Error! ', // Error message
                                                                                        );
                                                                                    },
                                                                                    success: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        var json = JSON.parse(
                                                                                            text, // Parse the response
                                                                                        );
                                                                                        // Check for errors in the response
                                                                                        if (json.HasError) {
                                                                                            webix.message({
                                                                                                title: '¡Error!', // Error title
                                                                                                type: 'alert-error',
                                                                                                text: json.AlertMessage, // Error message
                                                                                            });
                                                                                        } else {
                                                                                            webix.message(
                                                                                                'Apuesta Confirmada', // Success message
                                                                                            );
                                                                                        }
                                                                                    },
                                                                                },
                                                                            );
                                                                        $$('betEmailForm').setValues(
                                                                            $$('betEmailForm').getCleanValues(), // Reset form values
                                                                        );
                                                                        this.getTopParentView().hide(); // Close the window
                                                                    } else {
                                                                        webix.message({
                                                                            title: '¡Error!', // Error title
                                                                            type: 'alert-error',
                                                                            text: 'Correo y confirmar correo deben coincidir', // Error message
                                                                        });
                                                                    }
                                                                } else {
                                                                    webix.message({
                                                                        title: '¡Error!', // Error title
                                                                        type: 'alert-error',
                                                                        text: 'Completa los campos...', // Error message
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate(); // Validate the form on change
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show(); // Show the window
                            }
                        }
                    } catch (e) {
                        console.log(e); // Log any errors
                    }
                };
                var BIA = new AltenarSportsbook(
                    '#BIA_client_container', // Container for the sportsbook
                    options, // Options for the sportsbook
                );
                document.getElementById('BIA_client_container').parentNode.style.overflow = 'scroll'; // Set overflow style for the container
            });
        } else if (typeSkinITN == '4') {
            webix.require([skinJsITN], function () {
                window.altenarWSDK.init({
                    integration: skinIdITN, // Integration ID
                    culture: lng, // Language culture
                    token: profile.TokenSportsbook, // Token for the sportsbook
                    oddsFormat:
                        profile.oddsFormat != undefined
                            ? profile.oddsFormat // Odds format from the profile
                            : 0,
                });
                window.altenarWSDK.set({ token: profile.TokenSportsbook }); // Set the token
                window.ASB = window.altenarWSDK.addSportsBook({
                    props: {
                        routerType: 'memory', // Router type
                        page: 'overview', // Page type
                        onBetPlacement: (betIds) => {
                            try {
                                // Check if user relationship is online
                                if (devConfig.getOnRelationshipUserOnline()) {
                                    let userRelationship = JSON.parse(
                                        localStorage.getItem(
                                            'relationshipUserOnline', // Get user relationship from local storage
                                        ),
                                    );
                                    webix
                                        .ui({
                                            id: 'filterPopup31',
                                            view: 'window',
                                            position: 'center',
                                            modal: true,
                                            css: {
                                                'border-width': '0px !important',
                                                'border-radius': '10px !important',
                                            },
                                            head: {
                                                view: 'toolbar',
                                                cols: [
                                                    {
                                                        view: 'label',
                                                        label:
                                                            `<span style='color: #FFFFFF !important; padding-left: 10px !important;'>` +
                                                            _(
                                                                'CONFIRMACION DE APUESTA', // Confirmation label
                                                            ) +
                                                            `</span>`,
                                                    },
                                                    {
                                                        view: 'icon',
                                                        icon: 'wxi-close',
                                                        click: function () {
                                                            this.getTopParentView().hide(); // Close the window
                                                        },
                                                    },
                                                ],
                                                css: {
                                                    'background-color': '#404563', // Toolbar background color
                                                    color: 'white !important', // Toolbar text color
                                                },
                                            },
                                            body: {
                                                width: 500,
                                                height: 250,
                                                padding: 10,
                                                rows: [
                                                    {
                                                        view: 'label',
                                                        label:
                                                            `<span style='font-size: 20px; font-weight: bold'>` +
                                                            _('ID:') +
                                                            ' ' +
                                                            userRelationship.id +
                                                            `</span>`,
                                                        css: {
                                                            'text-align': 'center', // Center text alignment
                                                        },
                                                    },
                                                    {
                                                        view: 'label',
                                                        label:
                                                            `<span style='font-size: 20px; font-weight: bold'>` +
                                                            _('DOCUMENTO:') +
                                                            ' ' +
                                                            userRelationship.value +
                                                            `</span>`,
                                                        css: {
                                                            'text-align': 'center', // Center text alignment
                                                        },
                                                    },
                                                    {
                                                        view: 'label',
                                                        label:
                                                            `<span style='font-size: 20px; font-weight: bold; text-transform: uppercase'>` +
                                                            userRelationship.name +
                                                            `</span>`,
                                                        css: {
                                                            'text-align': 'center', // Center text alignment
                                                        },
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                view: 'button',
                                                                value: 'Cerrar sesión', // Logout button label
                                                                autowidth: true,
                                                                click: function () {
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                            'Account/LogoutRelationshipUser', // API endpoint for logout
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    localStorage.removeItem(
                                                                                        'relationshipUserOnline', // Remove user relationship from local storage
                                                                                    );
                                                                                    devConfig.setRelationshipUserOnline(
                                                                                        '', // Clear user relationship
                                                                                    );
                                                                                    $$('BIA_client').show(); // Show the client
                                                                                    $$('BIA_client_2').hide(); // Hide the second client
                                                                                    $$('BIA_client_ID').setValue(
                                                                                        '', // Reset client ID
                                                                                    );
                                                                                    $$('BIA_client_ID').refresh(); // Refresh client ID
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    localStorage.removeItem(
                                                                                        'relationshipUserOnline', // Remove user relationship from local storage
                                                                                    );
                                                                                    devConfig.setRelationshipUserOnline(
                                                                                        '', // Clear user relationship
                                                                                    );
                                                                                    $$('BIA_client').show(); // Show the client
                                                                                    $$('BIA_client_2').hide(); // Hide the second client
                                                                                    $$('BIA_client_ID').setValue(
                                                                                        '', // Reset client ID
                                                                                    );
                                                                                    $$('BIA_client_ID').refresh(); // Refresh client ID
                                                                                },
                                                                            },
                                                                        );
                                                                    this.getTopParentView().hide(); // Close the window
                                                                },
                                                            },
                                                            {
                                                                view: 'button',
                                                                type: 'form',
                                                                value: 'Continuar apostando', // Continue betting button label
                                                                css: 'webix_primary',
                                                                autowidth: true,
                                                                click: function () {
                                                                    this.getTopParentView().hide(); // Close the window
                                                                },
                                                            },
                                                        ],
                                                        css: {
                                                            display: 'flex',
                                                            'justify-content': 'center', // Center content
                                                            'align-items': 'center', // Align items
                                                            gap: '10px',
                                                            'margin-top': '15px !important',
                                                        },
                                                    },
                                                ],
                                                css: {
                                                    display: 'flex',
                                                    'flex-direction': 'column', // Column layout
                                                    'justify-content': 'center', // Center content
                                                    'align-items': 'center', // Align items
                                                    gap: '0px !important',
                                                },
                                            },
                                        })
                                        .show(); // Show the confirmation window
                                } else {
                                    // Check if the BetPhone is defined in the profile
                                    if (profile.BetPhone != undefined && profile.BetPhone) {
                                        webix
                                            .ui({
                                                view: 'window',
                                                id: 'windowBetPhone', // ID for the phone betting window
                                                move: false,
                                                position: 'center',
                                                head: {
                                                    view: 'toolbar',
                                                    cols: [
                                                        {
                                                            view: 'label',
                                                            label: 'Enviar SMS', // Label for sending SMS
                                                            align: 'center',
                                                        },
                                                        {
                                                            view: 'icon',
                                                            icon: 'wxi-close',
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Close the window
                                                            },
                                                        },
                                                    ],
                                                },
                                                body: {
                                                    view: 'form',
                                                    id: 'betPhoneForm', // ID for the phone betting form
                                                    elements: [
                                                        {
                                                            view: 'text',
                                                            label: 'Ingrese su celular:', // Label for phone input
                                                            name: 'Phone', // Name of the input
                                                            labelWidth: 150,
                                                            labelPosition: 'top',
                                                            required: true, // Required field
                                                        },
                                                        {
                                                            view: 'text',
                                                            label: 'Confirme  celular:', // Label for phone confirmation input
                                                            name: 'Phone2', // Name of the confirmation input
                                                            labelWidth: 150,
                                                            labelPosition: 'top',
                                                            required: true, // Required field
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    view: 'button',
                                                                    value: 'Cancelar', // Cancel button label
                                                                    click: function () {
                                                                        this.getTopParentView().hide(); // Close the window
                                                                        $$('betPhoneForm').setValues(
                                                                            $$('betPhoneForm').getCleanValues(), // Reset form values
                                                                        );
                                                                    },
                                                                },
                                                                {
                                                                    view: 'button',
                                                                    type: 'form',
                                                                    value: 'Enviar', // Send button label
                                                                    click: function ($e) {
                                                                        var values = $$('betPhoneForm').getValues(); // Get form values
                                                                        let params = {
                                                                            Phone: values.Phone, // Phone number
                                                                            Type: 'Bets', // Type of request
                                                                            Code: betIds[0], // Bet ID
                                                                        };
                                                                        // Validate the form
                                                                        if ($$('betPhoneForm').validate()) {
                                                                            // Check if phone numbers match
                                                                            if (values.Phone == values.Phone2) {
                                                                                webix
                                                                                    .ajax()
                                                                                    .headers({
                                                                                        'Content-type':
                                                                                            'application/json', // Set content type
                                                                                    })
                                                                                    .post(
                                                                                        devConfig.geturlApi() +
                                                                                        'Betshop/BetPhoneBetshop', // API endpoint
                                                                                        params, // Parameters for the request
                                                                                        {
                                                                                            error: function (
                                                                                                text,
                                                                                                data,
                                                                                                XmlHttpRequest,
                                                                                            ) {
                                                                                                webix.message(
                                                                                                    'Error! ', // Error message
                                                                                                );
                                                                                            },
                                                                                            success: function (
                                                                                                text,
                                                                                                data,
                                                                                                XmlHttpRequest,
                                                                                            ) {
                                                                                                var json = JSON.parse(
                                                                                                    text, // Parse the response
                                                                                                );
                                                                                                // Check for errors in the response
                                                                                                if (json.HasError) {
                                                                                                    webix.message({
                                                                                                        title: '¡Error!', // Error title
                                                                                                        type: 'alert-error',
                                                                                                        text: json.AlertMessage, // Error message
                                                                                                    });
                                                                                                } else {
                                                                                                    webix.message(
                                                                                                        'Apuesta Confirmada', // Success message
                                                                                                    );
                                                                                                }
                                                                                            },
                                                                                        },
                                                                                    );
                                                                                $$('betPhoneForm').setValues(
                                                                                    $$('betPhoneForm').getCleanValues(), // Reset form values
                                                                                );
                                                                                this.getTopParentView().hide(); // Close the window
                                                                            } else {
                                                                                webix.message({
                                                                                    title: '¡Error!', // Error title
                                                                                    type: 'alert-error',
                                                                                    text: 'Celular y confirmar celular deben coincidir', // Error message
                                                                                });
                                                                            }
                                                                        } else {
                                                                            webix.message({
                                                                                title: '¡Error!', // Error title
                                                                                type: 'alert-error',
                                                                                text: 'Completa los campos...', // Error message
                                                                            });
                                                                        }
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                    elementsConfig: {
                                                        on: {
                                                            onChange: function () {
                                                                this.validate(); // Validate the form on change
                                                            },
                                                        },
                                                    },
                                                },
                                            })
                                            .show(); // Show the window
                                    } else {
                                        // Check if the BetEmail is defined in the profile
                                        if (profile.BetEmail != undefined && profile.BetEmail) {
                                            webix
                                                .ui({
                                                    view: 'window',
                                                    id: 'windowBetEmail', // ID for the email betting window
                                                    move: false,
                                                    position: 'center',
                                                    head: {
                                                        view: 'toolbar',
                                                        cols: [
                                                            {
                                                                view: 'label',
                                                                label: 'Enviar Correo', // Label for sending email
                                                                align: 'center',
                                                            },
                                                            {
                                                                view: 'icon',
                                                                icon: 'wxi-close',
                                                                click: function () {
                                                                    this.getTopParentView().hide(); // Close the window
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    body: {
                                                        view: 'form',
                                                        id: 'betEmailForm', // ID for the email betting form
                                                        elements: [
                                                            {
                                                                view: 'text',
                                                                label: 'Ingrese su correo electrónico:', // Label for email input
                                                                name: 'Email', // Name of the input
                                                                labelWidth: 150,
                                                                labelPosition: 'top',
                                                                required: true, // Required field
                                                            },
                                                            {
                                                                view: 'text',
                                                                label: 'Confirme correo electrónico:', // Label for email confirmation input
                                                                name: 'Email2', // Name of the confirmation input
                                                                labelWidth: 150,
                                                                labelPosition: 'top',
                                                                required: true, // Required field
                                                            },
                                                            {
                                                                cols: [
                                                                    {
                                                                        view: 'button',
                                                                        value: 'Cancelar', // Cancel button label
                                                                        click: function () {
                                                                            this.getTopParentView().hide(); // Close the window
                                                                            $$('betEmailForm').setValues(
                                                                                $$('betEmailForm').getCleanValues(), // Reset form values
                                                                            );
                                                                        },
                                                                    },
                                                                    {
                                                                        view: 'button',
                                                                        type: 'form',
                                                                        value: 'Enviar', // Send button label
                                                                        click: function ($e) {
                                                                            var values = $$('betEmailForm').getValues(); // Get form values
                                                                            let params = {
                                                                                Email: values.Email, // Email address
                                                                                Type: 'Bets', // Type of request
                                                                                Code: betIds[0], // Bet ID
                                                                            };
                                                                            // Validate the form
                                                                            if ($$('betEmailForm').validate()) {
                                                                                // Check if emails match
                                                                                if (values.Email == values.Email2) {
                                                                                    webix
                                                                                        .ajax()
                                                                                        .headers({
                                                                                            'Content-type':
                                                                                                'application/json', // Set content type
                                                                                        })
                                                                                        .post(
                                                                                            devConfig.geturlApi() +
                                                                                            'BetShop/BetEmailBetshop', // API endpoint
                                                                                            params, // Parameters for the request
                                                                                            {
                                                                                                error: function (
                                                                                                    text,
                                                                                                    data,
                                                                                                    XmlHttpRequest,
                                                                                                ) {
                                                                                                    webix.message(
                                                                                                        'Error! ', // Error message
                                                                                                    );
                                                                                                },
                                                                                                success: function (
                                                                                                    text,
                                                                                                    data,
                                                                                                    XmlHttpRequest,
                                                                                                ) {
                                                                                                    var json =
                                                                                                        JSON.parse(
                                                                                                            text, // Parse the response
                                                                                                        );
                                                                                                    // Check for errors in the response
                                                                                                    if (json.HasError) {
                                                                                                        webix.message({
                                                                                                            title: '¡Error!', // Error title
                                                                                                            type: 'alert-error',
                                                                                                            text: json.AlertMessage, // Error message
                                                                                                        });
                                                                                                    } else {
                                                                                                        webix.message(
                                                                                                            'Apuesta Confirmada', // Success message
                                                                                                        );
                                                                                                    }
                                                                                                },
                                                                                            },
                                                                                        );
                                                                                    $$('betEmailForm').setValues(
                                                                                        $$(
                                                                                            'betEmailForm',
                                                                                        ).getCleanValues(), // Reset form values
                                                                                    );
                                                                                    this.getTopParentView().hide(); // Close the window
                                                                                } else {
                                                                                    webix.message({
                                                                                        title: '¡Error!', // Error title
                                                                                        type: 'alert-error',
                                                                                        text: 'Correo y confirmar correo deben coincidir', // Error message
                                                                                    });
                                                                                }
                                                                            } else {
                                                                                webix.message({
                                                                                    title: '¡Error!', // Error title
                                                                                    type: 'alert-error',
                                                                                    text: 'Completa los campos...', // Error message
                                                                                });
                                                                            }
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        ],
                                                        elementsConfig: {
                                                            on: {
                                                                onChange: function () {
                                                                    this.validate(); // Validate the form on change
                                                                },
                                                            },
                                                        },
                                                    },
                                                })
                                                .show(); // Show the window
                                        }
                                    }
                                }
                            } catch (e) {
                                console.log(e); // Log any errors
                            }
                        },
                    },
                    container: document.getElementById('BIA_client_container'), // Container for the sportsbook
                });
            });
        } else {
            webix.require([skinJsITN], function () {
                var options = {
                    token: profile.TokenSportsbook, // Token for the sportsbook
                    skinid: skinIdITN, // Skin ID
                    walletcode: profile.walletcodeSportbookITN, // Wallet code
                    full: true, // Full mode
                    page: 'prelive', // Page type
                    lang: lng, // Language
                    fixed: false, // Fixed mode
                };
                var BIA = new AltenarSportsbook(
                    '#BIA_client_container', // Container for the sportsbook
                    options, // Options for the sportsbook
                );
            });
        }
        // Return the template for the view
        if (typeSkinITN == '4') {
            return {
                view: 'template',
                template:
                    "<div id='BIA_client_container' style='overflow: scroll; height: 100%; width: 100%; background-color: black;'></div>",
                css: 'webix_template33', // CSS class for the template
            };
        }
        return {
            view: 'template',
            template: "<div id='BIA_client_container' style='overflow: scroll; height: 100%; width: 100%;'></div>",
        };
    }

    /**
     * Initializes the view.
     */
    init() {
        if (window.ASB != undefined) {
            window.ASB.remove(); // Remove the existing sportsbook instance
        }
    }
}

// FILE DOCUMENTED
